export class FaviconLinkMissingError extends Error {
  constructor(faviconPath: string) {
    super(
      `Icon <link> tag is missing. Will not assign favicon "${faviconPath}"`,
    );
    this.name = 'FaviconLinkMissingError';
  }
}
